import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { Button } from "../ui/button";
import { ShieldCheck, Check, ArrowRight } from "lucide-react";

const ADR_IMG = "https://images.pexels.com/photos/6170140/pexels-photo-6170140.jpeg";

export default function ADR() {
  const { t } = useLang();
  const bullets = [t("adr.b1"), t("adr.b2"), t("adr.b3"), t("adr.b4")];

  return (
    <section
      id="adr"
      data-testid="adr-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-6 order-2 lg:order-1 relative"
          >
            <div className="relative aspect-[4/5] rounded-sm overflow-hidden border border-white/10">
              <img src={ADR_IMG} alt="ADR safety" className="w-full h-full object-cover grayscale-[40%]" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
              <div className="absolute top-6 left-6 bg-[#F2B705] text-[#0A0A0A] px-4 py-2 text-xs font-bold tracking-widest uppercase rounded-sm">
                Certified DGSA
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-[#F2B705]/30 rounded-sm -z-10 hidden lg:block" />
          </motion.div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="gold-divider" />
              <span className="label-gold">{t("adr.label")}</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-tight mb-6">
              {t("adr.title")}
            </h2>
            <p className="text-neutral-300 leading-relaxed text-base lg:text-lg mb-8">
              {t("adr.body")}
            </p>
            <ul className="space-y-4 mb-10">
              {bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className="w-6 h-6 rounded-sm bg-[#F2B705]/10 border border-[#F2B705]/30 flex items-center justify-center shrink-0 mt-0.5">
                    <Check className="w-3.5 h-3.5 text-[#F2B705]" strokeWidth={3} />
                  </div>
                  <span className="text-neutral-200">{b}</span>
                </li>
              ))}
            </ul>
            <Link to="/kontakt" data-testid="adr-cta">
              <Button className="bg-[#F2B705] hover:bg-[#FFC933] text-[#0A0A0A] font-semibold rounded-sm px-8 py-6 group">
                <ShieldCheck className="mr-2 w-4 h-4" strokeWidth={2} />
                {t("adr.cta")}
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
